import { isNative } from "./platform";
import { getToken } from "./tokenStore";

/**
 * Gate the app behind device biometrics on native cold-start. No-ops on web
 * and when there is no stored session yet (the login screen is the gate then,
 * and there's nothing to protect until a token exists). Returns true when the
 * app may proceed, false on a hard auth failure/cancel.
 */
export async function ensureBiometricUnlock(): Promise<boolean> {
  if (!isNative()) return true;
  if (!getToken()) return true; // not logged in — nothing to protect yet

  const { BiometricAuth, BiometryError } = await import(
    "@aparajita/capacitor-biometric-auth"
  );
  try {
    const info = await BiometricAuth.checkBiometry();
    if (!info.isAvailable) return true; // no enrolled biometric → don't lock out
    await BiometricAuth.authenticate({
      reason: "Unlock Xynex Money",
      cancelTitle: "Cancel",
      allowDeviceCredential: true, // PIN/pattern fallback
      androidTitle: "Xynex Money",
      androidSubtitle: "Confirm it's you",
    });
    return true;
  } catch (err) {
    // BiometryError = user cancelled / failed / lockout. Any other error also
    // fails closed (better to re-prompt than to silently bypass the lock).
    if (err instanceof BiometryError) return false;
    return false;
  }
}
